import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { STRINGS, DOMAIN_LABEL, DIFF_LABEL, format } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("pmp_lang") || "tr");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next);
    localStorage.setItem("pmp_lang", next);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = STRINGS[lang] || STRINGS.en;
      const fallback = STRINGS.en[key] || key;
      return format(dict[key] || fallback, vars);
    },
    [lang]
  );

  const tDomain = useCallback((d) => (DOMAIN_LABEL[lang] || DOMAIN_LABEL.en)[d] || d, [lang]);
  const tDiff = useCallback((d) => (DIFF_LABEL[lang] || DIFF_LABEL.en)[d] || d, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tDomain, tDiff }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used inside LanguageProvider");
  return ctx;
}
